import Customer from '@/sections/customers/customers-page';
import ErrorLogs from '@/sections/customers/error-logs/error-logs-page.vue';
import CustomerFormsManager from '@/sections/customers/forms/customer-forms-manager.vue';
import FormHistoryScreen from '@/pages/forms-history-screen.vue';
const stringToBoolean = str => {
	const mapping = {
		true: true,
		false: false,
		all: 'all'
	};
	return mapping[str] !== undefined ? mapping[str] : false;
};

const generateErrorLogProps = route => ({
	id: route.params.id,
	companyId: route.params.companyId ? parseInt(route.params.companyId) : null,
	locationId: route.params.locationId
		? parseInt(route.params.locationId)
		: null,
	search: route.query.search || '',
	startDate: route.query.startDate || null,
	endDate: route.query.endDate || null,
	userId: route.query.userId || null,
	isResolved: stringToBoolean(route.query.isResolved),
	recordStart: route.query.recordStart
		? parseInt(route.query.recordStart)
		: 1,
	maxCount: route.query.maxCount ? parseInt(route.query.maxCount) : 10
});

export default [
	{
		name: 'clients-summary',
		path: '/clients',
		component: Customer,
		props: route => ({
			search: route.query.search,
			sortBy: route.query.sortBy || 'name',
			sortDirection: route.query.sortDirection || 'asc',
			favoritesort: stringToBoolean(route.query.favoritesort)
		}),
		meta: {
			authorization: {
				permissions: ['clients.read'],
				policies: ['SupportTech']
			}
		}
	},

	{
		name: 'customer-forms',
		path: '/clients/:customerId/forms',
		component: CustomerFormsManager,
		props: route => ({
			customerId: route.params.customerId,
			search: route.query.search || '',
			enabled:
				route.query.enabled === 'true'
					? true
					: route.query.enabled === 'false'
					? false
					: undefined,
			type: route.query.type || 'all'
		}),
		meta: {
			permissions: ['clients.read']
		}
	},
	{
		name: 'customer-error-logs',
		path: '/clients/:id/error-logs',
		component: ErrorLogs,
		props: generateErrorLogProps,
		meta: {
			authorization: {
				permissions: ['clients.read', 'errorLogs.read'],
				policies: ['SupportTech']
			}
		}
	},
	{
		name: 'customer-company-error-logs',
		path: '/clients/:id/company/:companyId/error-logs',
		component: ErrorLogs,
		props: generateErrorLogProps,
		meta: {
			authorization: {
				permissions: ['clients.read', 'errorLogs.read'],
				policies: ['SupportTech']
			}
		}
	},
	{
		name: 'customer-company-location-error-logs',
		path: '/clients/:id/company/:companyId/location/:locationId/error-logs',
		component: ErrorLogs,
		props: generateErrorLogProps,
		meta: {
			authorization: {
				permissions: ['clients.read', 'errorLogs.read'],
				policies: ['SupportTech']
			}
		}
	},
	{
		name: 'customer-form-history',
		path: '/clients/:customerId/forms/:changedEntityId/history',
		props: route => ({
			customerId: route.params.customerId,
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			search: route.query.search || '',
			minDatetime: route.query.minDatetime,
			maxDatetime: route.query.maxDatetime,
			changedByUserId: route.query.changedByUserId,
			SourceApplication: route.query.SourceApplication || 'VueSupport',
			entityType: route.query.entityType || 'FormRepositoryModel',
			changedEntityId: route.params.changedEntityId,
			page: parseInt(route.query.page) || 1,
			countPerPage: parseInt(route.query.countPerPage) || 10
		}),
		component: FormHistoryScreen,
		meta: {
			permissions: ['forms.read']
		}
	}
];
